var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3033 32.574L24.6967 34.2571C22.4784 36.581 18.8819 36.581 16.6637 34.2571C14.4454 31.9332 14.4454 28.1654 16.6637 25.8416L18.2703 24.1584M32.7297 25.8416L34.3363 24.1584C36.5546 21.8346 36.5546 18.0668 34.3363 15.7429C32.1181 13.419 28.5216 13.419 26.3033 15.7429L24.6967 17.426M21.5239 29.1654L29.4761 20.8345",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomLink);
export default __webpack_public_path__ + "static/media/Custom Link.53f5d728b15ad04746606e85f7234a09.svg";
export { ForwardRef as ReactComponent };